import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EventCardComponent } from '../event-card/event-card.component';
import { DatePipe, NgClass, NgIf, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { ImageComponent } from '@teamfoster/sdk/image';
import { UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';
import { EventDatePipe } from '../../pipes/event-date.pipe';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
  selector: 'app-event-card-inverted',
  standalone: true,
  imports: [
    ImageComponent,
    DatePipe,
    YoutubeComponent,
    EventDatePipe,
    RouterLink,
    NgClass,
    NgIf,
    NgOptimizedImage,
    FromDictionaryPipe,
    UrlRewritePipe,
    IconComponent,
  ],
  templateUrl: './event-card-inverted.component.html',
  styleUrl: './event-card-inverted.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventCardInvertedComponent extends EventCardComponent {
  hideImage = input<boolean>(false);
}
